import type {Cell} from 'react-table'

import {MemexColumnDataType} from '../api/columns/contracts/memex-column'
import type {TableDataType} from '../components/react_table/table-data-type'
import {isValueActionableColumn} from '../models/column-capabilities'

export function columnActionable(cell: Pick<Cell<TableDataType>, 'row' | 'column'>, columnType?: MemexColumnDataType) {
  // These column data types are never actionable
  if (columnType === undefined || !isValueActionableColumn(columnType)) {
    return false
  }

  // linked pull requests are only actionable if there is at least one linked PR
  if (columnType === MemexColumnDataType.LinkedPullRequests && cell.row.original.getLinkedPullRequests().length < 1) {
    return false
  }

  return true
}
